<template>
  <div class="wrap">已通过新窗口打开</div>
</template>

<script>
import { mapState } from "vuex";
import { getToken } from "@/CommonDP/utils";
export default {
  computed: {
    ...mapState({ enterpriseId: (state) => state.enterprise.enterpriseId, prjId: (state) => state.projectMg.prjObj.prjId })
  },
  created() {
    const token = getToken();
    setTimeout(() => {
      window.open(`${location.origin}/common-dp-report/#/chart/preview/${this.$route.name}?token=${token}&prjId=${this.prjId}&enterpriseId=${this.enterpriseId}`, "_blank");
    }, 500);
  }
};
</script>

<style lang="less" scoped>
.wrap {
  width: 100%;
  height: 100%;
  background-color: #fff;
}
</style>
